import axios from "axios";
import Swal from "sweetalert2";

/**
 * Lo que necesitan los PDF de la nota de venta para que lo que se imprime
 * SIEMPRE sume lo mismo que la nota.
 *
 * Por qué existe (nota 474, Refaccionaria Par, sep-2026): el PDF armaba los
 * renglones frescos del servidor pero tomaba subtotal/IVA/total de la tabla
 * ya cargada en pantalla. Si la nota se había editado en otra pestaña u otra
 * computadora, salía con renglones nuevos y totales viejos, y "no sumaba".
 */

const auth = () => ({
  headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
});

/**
 * Totales de la nota tal como están HOY en el servidor: los que cambian al
 * editarla (subtotal, IVA, total) y su descuento. El flete y la comisión TDC
 * NO van aquí: la nota guarda el flete como `flete` y la TDC vive en el
 * pedido, y cada pantalla ya los toma de su fuente.
 */
export async function totalesNotaActuales(idSurtido) {
  const { data } = await axios.get(`${process.env.REACT_APP_URL_SURTIDOS}/${idSurtido}`, auth());
  return {
    subTotal: Number(data?.subTotal) || 0,
    iva: Number(data?.iva) || 0,
    total_general: Number(data?.total_general) || 0,
    descuento: Number(data?.descuento) || 0,
  };
}

/**
 * Clave para juntar renglones en el PDF. Se juntan sólo si son el mismo
 * artículo AL MISMO precio y descuento: juntarlos sólo por artículo se
 * quedaba con el último precio y el importe salía mal (había notas con el
 * mismo artículo a 2 y 3 precios distintos).
 */
export const claveRenglon = (item) =>
  `${item.idArticulo}|${Number(item.precio) || 0}|${Number(item.descuento) || 0}`;

const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(
    Number(n) || 0
  );

/**
 * Compara lo que suman los renglones impresos ({cantidad, precio, descuento})
 * contra el subtotal guardado de la nota. Si no cuadran, avisa en lugar de
 * dejar que el PDF salga callado con un total que no corresponde.
 */
export function revisaCuadreNota(renglones, subTotal, numero) {
  const suma = (renglones || []).reduce(
    (t, r) => t + (Number(r.cantidad) || 0) * (Number(r.precio) || 0) * (1 - (Number(r.descuento) || 0) / 100),
    0
  );
  const dif = suma - (Number(subTotal) || 0);
  if (Math.abs(dif) > 1) {
    Swal.fire({
      icon: "warning",
      title: `La nota ${numero} no cuadra`,
      html:
        `Los renglones suman <b>${money(suma)}</b> pero la nota está guardada por <b>${money(subTotal)}</b> ` +
        `(diferencia ${money(dif)}).<br><br>Revisa la nota antes de mandarla al cliente.`,
    });
  }
  return { suma, dif };
}
